export const accountPrioritizationOptions = [
  'A: Very High',
  'B: High',
  'C: Medium',
  'D: Low',
  'E: Very Low'
]
